export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "index.worker.5a5a581362c14598c3d9.worker.js");
}
